import React, { Component } from 'react';
import { CircularProgress } from 'material-ui/Progress';

import './iframe.css';

class Iframe extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true
        };
    }

    onLoad() {
        this.setState({loading: false});
    }

    getLoad() {
        if (this.state.loading) {
            return (
                <div className="iframe-loader">
                    <div><CircularProgress /></div>
                    <p><small>Carregando...</small></p>
                </div>
            );
        }

        return null;
    }

    render() {
        const iframe_loader_classname = (this.state.loading) ? 'iframe-loading' : '';

        return (
            <div className={`iframe-container ${iframe_loader_classname}`} style={this.props.style}>
                {this.getLoad()}

                <iframe
                    src={this.props.src}
                    title={this.props.title || 'iframe'}
                    onLoad={this.onLoad.bind(this)} />
            </div>
        );
    }
}

export default Iframe;



// WEBPACK FOOTER //
// ./src/psuite-js/components/Iframe/index.js